import _invariant                    from 'invariant';
import PropTypes                     from 'prop-types';
import { mapProps }                  from 'recompose';
import { MapResourceNamePropTypes }  from './mapResourceName';
import { MAP_RESOURCE_PROP_API_URL } from './mapResourceProps.const';
import resourcesConfig               from '../../config/resources.config';
import url                           from '../../utils/url';


// @todo Update to move resourceName from prop to func arg.
const mapResourceItemApiUrlFromSlug = (/* Reserved for future config */) => (Component) => {

  const MapResourceItemApiUrlFromSlug = mapProps(({...props}) => {

    const {resourceName, resourceSlug} = props;

    _invariant(resourceSlug, `Missing 'resourceSlug'`);

    props[MAP_RESOURCE_PROP_API_URL] =
      url.addQueryParams(resourcesConfig[resourceName].apiPath, {page: 1, slug: resourceSlug});

    return props;

  })(Component);

  MapResourceItemApiUrlFromSlug.propTypes = {

    ...MapResourceNamePropTypes,

    // The slug of the resource.
    resourceSlug: PropTypes.string.isRequired,

  };

  MapResourceItemApiUrlFromSlug.displayName = 'MapResourceItemApiUrlFromSlug';

  return MapResourceItemApiUrlFromSlug;

};


export const MapResourceItemApiUrlFromSlugPropTypes = {

  // URL for the resource collection.
  [MAP_RESOURCE_PROP_API_URL]: PropTypes.string.isRequired,

};


export default mapResourceItemApiUrlFromSlug;


// WEBPACK FOOTER //
// ./src/components/resources/mapResourceItemApiUrlFromSlug.js